<div class="modal-container" [class]="getModalTypeClass()">
  <!-- Header -->
  <div class="modal-header">
    <div class="modal-header__content">
      @if (options.imagemUrl) {
        <img [src]="options.imagemUrl" class="modal-header__image" alt="Modal Icon">
      } @else {
        <mat-icon [class]="getIconClass()" class="modal-header__icon">
          {{getIcon()}}
        </mat-icon>
      }
      <h3 class="modal-header__title">{{options.titleText || options.title || getDefaultTitle()}}</h3>
    </div>
    @if (options.showCloseButton !== false) {
      <button class="modal-header__close" (click)="close()" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <!-- Content -->
  <div class="modal-content">
    <p class="modal-content__message">{{options.subtitleText || options.message}}</p>
  </div>

  <!-- Footer -->
  <div class="modal-footer">
    @if (options.listButtons && options.listButtons.length > 0) {
      @for (button of options.listButtons; track $index) {
        <button 
          mat-raised-button
          [class]="getButtonClass()"
          [style.background]="button.fill === 'outline' ? 'transparent' : ''"
          [style.color]="button.fill === 'outline' ? '#b90066' : 'white'"
          [style.border]="button.fill === 'outline' ? '2px solid #b90066' : 'none'"
          (click)="onButtonClick(button)"
          class="modal-footer__button">
          {{button.textButton}}
        </button>
      }
    } @else {
      <button 
        mat-raised-button 
        [class]="getButtonClass()"
        (click)="close()"
        class="modal-footer__button">
        {{options.buttonText || 'OK'}}
      </button>
    }
  </div>
</div>
